import React, { Component, PropTypes } from 'react';
import zxcvbn from 'zxcvbn';

import PasswordMeter from './PasswordMeter.js';

class PasswordInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPasswordHelp: false,
      showPasswordStrength: false
    };

    this.checkPasswordRequirements = this.checkPasswordRequirements.bind(this);
  }

  checkPasswordRequirements() {
    const { value } = this.props;
    if (value.length < 7) {
      this.setState({ showPasswordHelp: true });
      return false;
    }

    this.setState({ showPasswordHelp: false });
    return true;
  }

  showPasswordStrength() {
    this.setState({ showPasswordStrength: true });
  }

  hidePasswordStrength() {
    this.setState({ showPasswordStrength: false });
  }

  render() {
    let passwordScore = zxcvbn(this.props.value).score;

    // If we have a password, set the minimum score it can have to 1.
    if (this.props.value && passwordScore < 1) {
      passwordScore = 1;
    }

    let passwordHelpLabel;
    if (this.state.showPasswordHelp) {
      let helpLabelClasses = ['text-help'];
      if (this.props.lightVariant) {
        helpLabelClasses.push('text-help--light');
      }

      passwordHelpLabel = <p className={helpLabelClasses.join(' ')}>We require passwords to be at least 7 characters long.</p>
    }

    return (
      <div className="PasswordInput input-group">
        <input type="password"
          className={this.props.inputClassName}
          disabled={this.props.disabled}
          name={this.props.name}
          value={this.props.value}
          placeholder={this.props.placeholder}
          onChange={this.props.onChange}
          onFocus={() => {
            this.showPasswordStrength();
          }}
          onBlur={() => {
            this.hidePasswordStrength();
            this.checkPasswordRequirements();
          }} />

        <PasswordMeter lightVariant={this.props.lightVariant} isVisible={this.state.showPasswordStrength} score={passwordScore} />

        {passwordHelpLabel}
      </div>
    );
  }
}

PasswordInput.propTypes = {
  inputClassName: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,

  lightVariant: PropTypes.bool
};

export default PasswordInput;



// WEBPACK FOOTER //
// ./src/components/PasswordInput.js